<template>
  <section class="form-fw__content--consolidated-report">
    <transition name="fade">
      <div v-if="isSuccess" class="info__content">
        <v-layout v-if="items.length" class="info__subtitle" align-center>
          <v-flex xs12>
            <p>{{ $t(`${namespace}.subtitle`) }}</p>
          </v-flex>
        </v-layout>

        <div v-if="items.length" class="table">
          <v-layout class="table__header bg-custom" align-center>
            <v-flex xs1></v-flex>
            <v-flex xs4>{{ $t('Common.companies') | capitalizeFirstLetter }}</v-flex>
            <v-flex xs3>{{ $t('Common.period') | capitalizeFirstLetter }}</v-flex>
            <v-flex xs2>{{ $t('Common.createdAt') | capitalizeFirstLetter }}</v-flex>
            <v-flex xs2>{{ $t('Common.validUntil') | capitalizeFirstLetter }}</v-flex>
          </v-layout>

          <v-list subheader two-line class="table__body">
            <div v-for="(item, i) in items" :key="`tr-${i}`">
              <v-list-tile class="table__body">
                <v-list-tile-content>
                  <v-list-tile-sub-title>
                    <v-layout align-center>
                      <v-flex xs1 class="table__body__download-button">
                        <v-tooltip top max-width="300">
                          <template v-slot:activator="{ on }">
                              <button @click="downloadReportById(item.id, item.fileName)" v-on="on">
                                <img
                                  src="@/assets/icons/icn_download.svg"
                                  alt="Icon: Download"
                                  width="20"
                                />
                              </button>
                          </template>

                          <span class="text-capitalize">{{ $t(`${namespace}.fileDownload`) }}</span>
                        </v-tooltip>
                      </v-flex>

                      <v-flex xs4>
                        <span
                          v-if="item.params.companies.length > 1"
                          class="table__body__companies"
                        >
                          {{ `${item.params.companies[0].name} ${$t(`${namespace}.more`)} ${item.params.companies.length - 1}` }}
                          <v-icon color="accent" size="16" @click="displayCompanies(item.params.companies)">
                              add_circle_outline
                          </v-icon>
                        </span>
                        <span v-else>{{ item.params.companies[0].name }}</span>
                      </v-flex>

                      <v-flex xs3>
                        <span
                          class="text--ellipsis"
                        >{{ moment(item.params.startAt).format('DD/MM/YYYY') }} {{$t('Common.to')}} {{ moment(item.params.endAt).format('DD/MM/YYYY') }}</span>
                      </v-flex>

                      <v-flex xs2>
                        <span
                          class="text--ellipsis"
                        >{{ moment(item.updatedAt).format('DD/MM/YYYY') }}</span>
                      </v-flex>
                      <v-flex xs2>
                        <span
                          class="text--ellipsis"
                        >{{ moment(new Date(item.updatedAt), 'DD/MM/YYYY').add(8, 'days').format('DD/MM/YYYY') }}</span>
                      </v-flex>
                    </v-layout>
                  </v-list-tile-sub-title>
                </v-list-tile-content>
              </v-list-tile>

              <v-divider />
            </div>
          </v-list>
        </div>

        <EmptyState v-else image="cost-center" :text="$t(`${namespace}.noneFound`)" />

        <CompaniesDialog :items="companiesDisplayed" :visible="!!companiesDisplayed.length" @close="displayCompanies" />
      </div>
    </transition>

    <transition name="fade">
      <v-layout v-if="isFailed" align-center justify-center column fill-height>
        {{ $t('Common.genericErrorMsg') }}
        <br />
        <a
          :title="$t('Common.tryAgain')"
          class="accent--text"
          @click.prevent="handleReloadData"
        >{{ $t('Common.tryAgain') }}.</a>
      </v-layout>
    </transition>
  </section>
</template>

<script>
import {
  STATUS_IS_LOADING,
  STATUS_SUCCESS,
  STATUS_FAILED
} from 'utils/constants'
import EmptyState from 'components/EmptyState'
import CompaniesDialog from 'components/reports/consolidated/CompaniesDialog'

export default {
  name: 'ConsolidatedReportsTable',
  props: {
    items: {
      type: Array,
      required: true
    },
    status: {
      type: Number,
      default: STATUS_IS_LOADING
    }
  },
  components: {
    EmptyState,
    CompaniesDialog
  },
  computed: {
    isLoading () {
      return this.status === STATUS_IS_LOADING
    },

    isSuccess () {
      return this.status === STATUS_SUCCESS
    },

    isFailed () {
      return this.status === STATUS_FAILED
    }
  },
  data () {
    return {
      namespace: 'Views.ConsolidatedReportsPage',
      companiesDisplayed: []
    }
  },
  methods: {
    downloadReportById (id, fileName) {
      this.$emit('downloadReportById', id, fileName)
    },

    handleReloadData () {
      this.$emit('getReports')
    },

    displayCompanies (companies) {
      companies && companies.length
        ? this.companiesDisplayed = [...companies]
        : this.companiesDisplayed = []
    }
  }
}
</script>

<style lang="scss">
.table__header.bg-custom {
  background-color: #f6f6f6 !important;
}

.info__content {
  padding: 22px 0;
}

.info__subtitle {
  padding: 0 28px 22px;

  p {
    font-weight: bold;
    font-size: 14px;
    margin: 0;
    font-style: normal;
    font-stretch: normal;
    line-height: normal;
    letter-spacing: normal;
    color: #4a4b4a;
  }
}

.table__body__companies {
  display: block;
  overflow: hidden;
  padding-right: 10px;
  white-space: normal;
  max-width: 100%;
  line-height: 1.6;

  .v-icon {
    cursor: pointer;
    margin-left: 3px;
    margin-top: 3px;
    position: absolute;
  }
}

.table__body__download-button {
    text-align: center;
}

.table__body .v-list__tile {
  padding: 0;
}

</style>
